import styled from 'styled-components';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/ui/Tooltip';

const CheckboxInputLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

const CheckboxInputBox = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border: 2px solid var(--text-disabled);
  background: var(--surface-muted);
  display: inline-grid;
  place-content: center;
  transition: box-shadow 120ms, border-color 120ms, background 120ms;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--poki-blue);
  }

  &:disabled {
    opacity: 0.6;
  }

  &::after {
    content: "";
    width: 10px;
    height: 10px;
    transform: scale(0) rotate(0deg);
    transition: transform 120ms ease-in-out;
    clip-path: polygon(14% 53%, 0 66%, 40% 100%, 100% 22%, 85% 9%, 39% 74%);
    background: white;
  }

  &:checked {
    border-color: var(--poki-blue);
    background: var(--poki-blue);
  }

  &:checked::after {
    transform: scale(1);
  }

  &:hover:not(:disabled) {
    border-color: var(--poki-blue);
  }
`;

const CheckboxInputText = styled.span`
  font-size: 14px;
  font-weight: bold;
`;

const TooltipContentWrapper = styled.span`
    margin-left: auto;
`;

export default function CheckboxInput({
    id,
    label,
    tooltip,
    checked,
    disabled,
    onChange,
}) {
    const handleOnChangeCallback = () => {
        onChange(!checked);
    };

    return (
        <CheckboxInputLabel htmlFor={id} disabled={disabled}>
            <CheckboxInputBox
                id={id}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={handleOnChangeCallback}
            />
            {tooltip && (
                <Tooltip content={tooltip}>
                    <TooltipContentWrapper>
                        <CheckboxInputText>{label}</CheckboxInputText>
                    </TooltipContentWrapper>
                </Tooltip>
            )}
            {!tooltip && label && <CheckboxInputText>{label}</CheckboxInputText>}
        </CheckboxInputLabel>
    );
}

CheckboxInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

CheckboxInput.defaultProps = {
    id: undefined,
    label: undefined,
    tooltip: undefined,
    disabled: false,
    checked: false,
};
